import axios from 'axios';
import { ADMIN_API } from './adminApi';


/**
 * Quién está logueado: { email, nombre, rol }.
 *
 * Se pide EN PARALELO con los datos de cada página, no antes, para no sumarle
 * un viaje de ida y vuelta al arranque en frío de Render.
 */
export const getSesion = () => axios
  .get(`${ADMIN_API}/api/admin/sesion`, { withCredentials: true })
  .then((r) => r.data);
